<template>
	<div id="spinner-overlay" data-testid="spinner" v-if="showSpinner">
		<div class="spinner"></div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name: "spinner",
	computed: {
		...mapGetters({
			showSpinner: 'getShowSpinner',
		}),
	},
}

</script>
